const directPlacementPayment = {
  id: null,
  directPlacementId: null,
  receivedAt: null,
  amount: null,
  paymentNotes: null,
  createdBy: null,
  createdAt: null,
  updatedAt: null,
  updatedBy: null
}

export default () => Object.assign({}, directPlacementPayment)
